export default "__VITE_ASSET__Mk12_bSV__"